import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { NewTitleGraphqlFragmentDoc } from '../fragments/NewTitle.fragment';
export type GetNewTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	date: Types.Scalars['Date']['input'];
	language: Types.Scalars['Language']['input'];
	filter?: Types.InputMaybe<Types.TitleFilter>;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	first?: Types.Scalars['Int']['input'];
	profile?: Types.InputMaybe<Types.PosterProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	priceDrops: Types.Scalars['Boolean']['input'];
	platform: Types.Platform;
	bucketType?: Types.InputMaybe<Types.NewDateRangeBucket>;
	pageType?: Types.NewPageType;
	showDateBadge: Types.Scalars['Boolean']['input'];
	availableToPackages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;

export type GetNewTitlesQuery = {
	__typename?: 'Query';
	newTitles: {
		__typename?: 'NewTitlesConnection';
		totalCount: number;
		edges?: Array<{
			__typename?: 'NewTitlesEdge';
			cursor: string;
			watchNowOffer?: {
				__typename: 'Offer';
				lastChangeRetailPrice?: string | null;
				lastChangePercent?: number | null;
				id: string;
				standardWebURL?: string | null;
				preAffiliatedStandardWebURL?: string | null;
				streamUrl?: string | null;
				streamUrlExternalPlayer?: string | null;
				country: any;
				retailPrice?: string | null;
				retailPriceValue?: number | null;
				lastChangeRetailPriceValue?: number | null;
				currency?: string | null;
				presentationType: Types.PresentationType;
				monetizationType: Types.MonetizationType;
				availableTo?: any | null;
				dateCreated?: any | null;
				newElementCount?: number | null;
				mediaDealId?: number | null;
				package: {
					__typename?: 'Package';
					id: string;
					icon: string;
					packageId: number;
					clearName: string;
					shortName: string;
					technicalName: string;
					iconWide: string;
					hasRectangularIcon: boolean;
				};
			} | null;
			node:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'MovieContent';
							title: string;
							shortDescription?: string | null;
							fullPath: string;
							posterUrl?: string | null;
							runtime?: number | null;
							isReleased: boolean;
							scoring: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							};
							genres: Array<{ __typename?: 'Genre'; translation: string }>;
							upcomingReleases?: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
								package?: { __typename?: 'Package'; id: string; shortName: string } | null;
							}>;
						};
						availableTo?: Array<{
							__typename?: 'AvailableTo';
							availableCountDown: number;
							availableToDate: any;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				  }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						show: {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							content: {
								__typename?: 'ShowContent';
								title: string;
								shortDescription?: string | null;
								fullPath: string;
								posterUrl?: string | null;
								runtime?: number | null;
								scoring: {
									__typename: 'Scoring';
									imdbScore?: number | null;
									imdbVotes?: number | null;
									tmdbPopularity?: number | null;
									tmdbScore?: number | null;
									jwRating?: number | null;
									tomatoMeter?: number | null;
									certifiedFresh?: boolean | null;
									hideJWRating: boolean;
								};
								genres: Array<{ __typename?: 'Genre'; translation: string }>;
							};
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							seenState: { __typename?: 'ShowSeenState'; progress: number };
						};
						content: {
							__typename?: 'SeasonContent';
							seasonNumber: number;
							title: string;
							shortDescription?: string | null;
							fullPath: string;
							posterUrl?: string | null;
							runtime?: number | null;
							isReleased: boolean;
							scoring: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							};
							genres: Array<{ __typename?: 'Genre'; translation: string }>;
							upcomingReleases?: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
								package?: { __typename?: 'Package'; id: string; shortName: string } | null;
							}>;
						};
						availableTo?: Array<{
							__typename?: 'AvailableTo';
							availableCountDown: number;
							availableToDate: any;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
				  };
		}> | null;
		pageInfo: { __typename?: 'PageInfo'; endCursor: string; hasPreviousPage: boolean; hasNextPage: boolean };
	};
};

export const GetNewTitlesDocument = gql`
	query GetNewTitles(
		$country: Country!
		$date: Date!
		$language: Language!
		$filter: TitleFilter
		$after: String
		$first: Int! = 10
		$profile: PosterProfile
		$format: ImageFormat
		$priceDrops: Boolean!
		$platform: Platform!
		$bucketType: NewDateRangeBucket
		$pageType: NewPageType! = NEW
		$showDateBadge: Boolean!
		$availableToPackages: [String!]
	) {
		newTitles(
			country: $country
			date: $date
			filter: $filter
			after: $after
			first: $first
			priceDrops: $priceDrops
			bucketType: $bucketType
			pageType: $pageType
		) {
			totalCount
			edges {
				...NewTitleGraphql
			}
			pageInfo {
				endCursor
				hasPreviousPage
				hasNextPage
			}
		}
	}
	${NewTitleGraphqlFragmentDoc}
`;
